import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../IntroducedRegistration/IntroducedInvestorRegistration.scss';
import { CompactHeader } from '../../../components/CompactHeader/CompactHeader';
import { CompactFooter } from '../../../components/CompactFooter/CompactFooter';

/**
 * Shown when a non-Indian national answers "No" to the OCI card question at self-registration
 * (user 2026-10-12). The server closed the registration without creating an account and emailed
 * the person; they can register again once they have the card. Same layout as ThankYouMessage.
 */
const OciCardRequired: React.FC = () => {
  const navigate = useNavigate();
  const state = useLocation().state as { email?: string; introduced?: boolean } | null;
  const email = state?.email;
  // Introduced investors come back through the link in their introduction email.
  const introduced = state?.introduced === true;

  return (
    <>
      <CompactHeader />

      <section className="login-form-style4 steps4-sec section-padding">
        <div className="container">
          <div className="row justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
            <div className="col-lg-8 col-md-10 col-sm-12">
              <div className="login-form-style3-main">
                <div className="login-form-style3-main_full">
                  <div className="login-register_style3-head text-center">
                    <div className="thank-you-icon mb-3">
                      <i className="fas fa-id-card" style={{ fontSize: '2.5rem', color: '#3e6f7c' }}></i>
                    </div>
                    <h2 style={{ fontSize: '1.4rem', color: '#3e6f7c', marginBottom: '1rem', textAlign: 'center' }}>
                      OCI Card Required
                    </h2>
                  </div>

                  <div className="login-register3-form-middle">
                    <div style={{ marginBottom: '1.25rem', textAlign: 'left' }}>
                      <p style={{ fontSize: '13px', color: '#475569', lineHeight: '1.5', marginBottom: '0.75rem' }}>
                        {introduced
                          ? 'An OCI (Overseas Citizen of India) card is needed to register as an OCI investor on Facilon.'
                          : 'An OCI (Overseas Citizen of India) card is needed to register as an investor on Facilon as a non-Indian national.'}
                        {' '}As you do not have one, we have not created an account.
                      </p>
                      <p style={{ fontSize: '13px', color: '#475569', lineHeight: '1.5', marginBottom: '0.75rem' }}>
                        {email
                          ? <>We have emailed the details to <strong>{email}</strong>.</>
                          : <>We have emailed you the details.</>}
                        {' '}{introduced
                          ? 'Once you have your OCI card, open the registration link in your introduction email again and continue.'
                          : 'Once you have your OCI card, you are welcome to register again.'}
                      </p>
                      <p style={{ fontSize: '13px', color: '#475569', lineHeight: '1.5', marginBottom: '1rem' }}>
                        If you are not of Indian origin, or have any questions, please contact us at{' '}
                        <a href="mailto:support@facilonservices.com" style={{ color: '#3e6f7c', fontWeight: 500 }}>
                          support@facilonservices.com
                        </a>.
                      </p>
                    </div>

                    <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                      <button
                        type="button"
                        className="button-2"
                        onClick={() => navigate('/')}
                        style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                      >
                        <i className="fas fa-home"></i>
                        Go to Homepage
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CompactFooter />
    </>
  );
};

export default OciCardRequired;
